export const COMPLIANCE_POLICY_STATES = {
  COMPLIANT: 'Compliant',
  NOT_COMPLIANT: 'Not compliant',
};

export const COMPLIANCE_SIGNING_STATES = {
  SIGNED: 'Signed',
  NOT_SIGNED: 'Not signed',
};

export const INTERACTION_ACTIONS = {
  VIEWED: 'VIEWED',
  SIGNED: 'SIGNED',
};

export const INTERACTION_ACTIONS_VIEW = {
  SIGNED: 'Signed',
  VIEWED: 'Viewed',
};
